import { render, staticRenderFns } from "./SurrenderReqEmailPop.vue?vue&type=template&id=06eee30a&scoped=true"
import script from "./SurrenderReqEmailPop.vue?vue&type=script&lang=js"
export * from "./SurrenderReqEmailPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eee30a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06eee30a')) {
      api.createRecord('06eee30a', component.options)
    } else {
      api.reload('06eee30a', component.options)
    }
    module.hot.accept("./SurrenderReqEmailPop.vue?vue&type=template&id=06eee30a&scoped=true", function () {
      api.rerender('06eee30a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SurrenderReqEmailPop.vue"
export default component.exports